import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Layout from "./components/Layout.jsx";
import Portada from "./periodico/Portada.jsx";
import temas from "./temas/registry.js";
import { IDIOMA, tr } from "./i18n/idioma";

// Rutas fuera del registry: metodología y las secciones del periódico. Las
// plantillas (noticia, estudio, episodio) son UNA por tipología; su contenido
// llega del feed en tiempo de ejecución (periodico/feed.js).
const Metodologia = React.lazy(() => import("./temas/metodologia.jsx"));
const Noticias = React.lazy(() => import("./periodico/Noticias.jsx"));
const Noticia = React.lazy(() => import("./periodico/Noticia.jsx"));
// Guías prácticas (2026-10-31): sustituyen a los estudios automáticos. periodico/Estudios.jsx
// queda archivado (sin ruta); /estudios redirige a /guias (también con 301 en public/_redirects).
const Guias = React.lazy(() => import("./guias/Guias.jsx"));
const GuiaPagina = React.lazy(() => import("./guias/Guias.jsx").then((m) => ({ default: m.GuiaPagina })));
const Expedientes = React.lazy(() => import("./periodico/Expedientes.jsx"));
const Podcast = React.lazy(() => import("./periodico/Podcast.jsx"));
const Episodio = React.lazy(() => import("./periodico/Podcast.jsx").then((m) => ({ default: m.Episodio })));
const Suscribete = React.lazy(() => import("./periodico/Suscribete.jsx"));
const Opinion = React.lazy(() => import("./periodico/Opinion.jsx"));
const Privacidad = React.lazy(() => import("./periodico/Privacidad.jsx"));
const Articulo = React.lazy(() => import("./periodico/Opinion.jsx").then((m) => ({ default: m.Articulo })));

// Cada expediente se carga en diferido desde su `load` del registry. React.lazy se
// resuelve al `export default` del .jsx del tema (importado con alias, nunca
// por su nombre literal `App`).
const temasLazy = temas.map((tema) => ({
  ...tema,
  Componente: React.lazy(tema.load),
}));

function Cargando() {
  return (
    <div className="ym-cargando" role="status" aria-live="polite">
      {tr("Cargando…", "Loading…")}
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter basename={IDIOMA === "en" ? "/en" : undefined}>
      <Layout>
        <Suspense fallback={<Cargando />}>
          <Routes>
            <Route path="/" element={<Portada />} />
            <Route path="/noticias" element={<Noticias />} />
            <Route path="/noticias/:slug" element={<Noticia />} />
            <Route path="/guias" element={<Guias />} />
            <Route path="/guias/:slug" element={<GuiaPagina />} />
            <Route path="/estudios/*" element={<Navigate to="/guias" replace />} />
            <Route path="/expedientes" element={<Expedientes />} />
            <Route path="/podcast" element={<Podcast />} />
            <Route path="/podcast/:slug" element={<Episodio />} />
            <Route path="/suscribete" element={<Suscribete />} />
            <Route path="/suscribete/nueva-contrasena" element={<Suscribete />} />
            <Route path="/opinion" element={<Opinion />} />
            <Route path="/privacidad" element={<Privacidad />} />
            <Route path="/opinion/:slug" element={<Articulo />} />
            <Route path="/metodologia" element={<Metodologia />} />
            {temasLazy.map(({ id, path, Componente }) => (
              <Route key={id} path={path} element={<Componente />} />
            ))}
          </Routes>
        </Suspense>
      </Layout>
    </BrowserRouter>
  );
}
